// extracted by mini-css-extract-plugin
export default {"tag":"StatusTag_tag__i1mIa","dot":"StatusTag_dot__HnJ5a"};